import { Address } from './address';
import { AbstractCategory } from './categories';
import { ImageType } from './files';
import { ListingBrief } from './listings';
import { OrderBrief } from './orders';

export enum UserTypes {
  MANAGER = 1,
  CAPTAIN = 3,
  SELLER = 4,
  CUSTOMER = 5,
}

export const UserTypesMap: {
  [key: string]: string;
} = {
  [UserTypes.MANAGER]: 'manager',
  [UserTypes.CAPTAIN]: 'delivery',
  [UserTypes.SELLER]: 'seller',
  [UserTypes.CUSTOMER]: 'customer',
};

export enum PermissionTypes {
  DATA_ENTRY = 1,
  CUSTOMER_SUPPORT = 2,
  TECHNICAL_SUPPORT = 3,
  LOGISTICS_MANAGER = 4,
  ACCOUNTANT = 5,
  LEVEL_6 = 6,
  LEVEL_7 = 7,
  LEVEL_8 = 8,
  LEVEL_9 = 9,
  ADMIN = 10,
}

export const PermissionTypesIndexToEnum = {
  1: 'support',
  2: 'customer_support',
  3: 'technical_support',
  4: 'logistics_manager',
  5: 'accountant',
  6: 'level_6',
  7: 'level_7',
  8: 'level_8',
  9: 'level_9',
  10: 'admin',
};

export const PermissionTypesMap: {
  [key: string]: string;
} = {
  [PermissionTypes.DATA_ENTRY]: 'Data Entry',
  [PermissionTypes.CUSTOMER_SUPPORT]: 'Customer Support',
  [PermissionTypes.TECHNICAL_SUPPORT]: 'Technical Support',
  [PermissionTypes.LOGISTICS_MANAGER]: 'Logistics Manager',
  [PermissionTypes.ACCOUNTANT]: 'Accountant',
  [PermissionTypes.LEVEL_6]: 'Level 6',
  [PermissionTypes.LEVEL_7]: 'Level 7',
  [PermissionTypes.LEVEL_8]: 'Level 8',
  [PermissionTypes.LEVEL_9]: 'Level 9',
  [PermissionTypes.ADMIN]: 'Admin',
};

export enum MerchantPermissionTypes {
  MAINTAINANCE = 3,
  ADMIN = 5,
}

export const MerchantPermissionTypesMap: {
  [key: string]: string;
} = {
  [MerchantPermissionTypes.MAINTAINANCE]: 'Maintainance',
  [MerchantPermissionTypes.ADMIN]: 'Admin',
};

export interface Manager extends AbstractUserInfo {
  enumValue: UserTypes.MANAGER;
  is_disabled: boolean;
  type: 'manager';
  level_name: string;
  level_enum: number;
}

export interface SellerWorkforce {
  seller_id: number;
  store_id: number;
  seller_name: string;
  store_name_en: string;
  store_name_ar: string;
  access_level: number;
  access_level_name: string;
}

interface Carrierobject {
  id: number;
  is_disabled: boolean;
  carrier_type: number;
  carrier_type_name: string;
}

export interface AbstractUserInfo {
  type: string;
  id: number;
  first_name: string;
  last_name: string;
  region: number;
  verified_email: boolean;
  verified_phone: boolean;
  has_password: boolean;
  enabled_mfa: boolean;
  finished_signup: boolean;
  fcm_id?: string;
  locale: string;
  phone?: string;
  email?: string;
  freshdesk_restore_id?: string;
  login_history: LoginHistory[];
}

export interface CustomerUserInfo extends AbstractUserInfo {
  added_preferred_categories: boolean;
  skipped_pass: boolean;
  selected_region: boolean;
  selected_sex: boolean;
  is_male: boolean;
  added_birth_year: boolean;
  birth_year: number;
  credit_balance: String;
  watched_listings: ListingBrief[];
  preferred_categories: AbstractCategory[];
  orders: OrderBrief[];
  addresses: Address[];
  cart_items: any[];
  credit_cards: any[];
}

export interface CaptainUserInfo extends AbstractUserInfo {
  id_number: number;
  license_number: number;
  tax_id: string;
  tax_type: number;
  deduction_at_source?: string;
  bank_account_number?: number;
  bank_branch_number?: number;
  bank_number: number;
  carrier_object: Carrierobject;
  license_image: ImageType;
  business_bank_statement: ImageType;
  business_tax_certificate: ImageType;
  business_das_certificate: ImageType;
}

export interface MerchantUserInfo extends AbstractUserInfo {
  id_number: number;
}

interface LoginHistory {
  id: number;
  datetime: string;
  first_factor: number;
  second_factor: any;
  ip: string;
  browser: string;
  platform: string;
  request_url: string;
  request_method: string;
}
